import { ConsumptionData } from 'src/models/Consumption'
import { get } from './axios'

//////////////////////////////////////////////////////////////////////
// GET
//////////////////////////////////////////////////////////////////////

/**
 * getDailyConsumptions
 */

export type DailyParams = {
  userId: number
  fromDate: string // YYYY-MM-DD
  toDate: string // YYYY-MM-DD
}

export const dailyDateFormat = 'YYYY-MM-DD'

export const getDailyConsumptions = async ({ userId, ...rest }: DailyParams) => {
  return await get<ConsumptionData>(`/v1/users/${userId}/consumptions/daily`, rest)
}

/**
 * getEVConsumption
 */

export type EVConsumptionParams = {
  userId: number
  year: number
  month: number
}

export const getEVConsumption = async ({ userId, ...rest }: EVConsumptionParams) => {
  return await get<{ consumption: number | null }>(`/v1/users/${userId}/consumptions/evConsumption`, rest)
}

/**
 * getHourlyConsumptions
 */

export type HourlyParams = {
  userId: number
  fromDate: string // YYYY-MM-DD HH:mm:ss
  toDate: string // YYYY-MM-DD HH:mm:ss
}

export const hourlyDateFormat = 'YYYY-MM-DD HH:mm:ss'

export const getHourlyConsumptions = async ({ userId, ...rest }: HourlyParams) => {
  return await get<ConsumptionData>(`/v1/users/${userId}/consumptions/hourly`, rest)
}

/**
 * getMonthlyConsumptions
 */

export type MonthlyParams = {
  userId: number
  fromDate: string // YYYY-MM
  toDate: string // YYYY-MM
}

export const monthlyDateFormat = 'YYYY-MM'

export const getMonthlyConsumptions = async ({ userId, ...rest }: MonthlyParams) => {
  return await get<ConsumptionData>(`/v1/users/${userId}/consumptions/monthly`, rest)
}
